import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function WelcomePage() {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-between relative overflow-hidden"
      style={{ background: '#0A0A12' }}
      data-testid="welcome-page"
    >
      {/* Premium dark gradient overlay */}
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(135deg, rgba(233,30,99,0.30) 0%, rgba(139,92,246,0.24) 25%, rgba(37,99,235,0.20) 50%, rgba(6,182,212,0.16) 75%, rgba(10,10,18,0.85) 100%)',
        }}
      />
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(to bottom, transparent 35%, rgba(10,10,18,0.55) 70%, rgba(10,10,18,0.98) 100%)',
        }}
      />

      {/* Content */}
      <div className="relative z-10 flex-1 flex flex-col items-center justify-center px-6 w-full max-w-md">
        <img
          src="/radius-logo.png"
          alt="RADIUS — Expand Your Circle"
          className="w-64 max-w-[90%] object-contain"
          data-testid="welcome-brand-logo"
        />
        <p className="text-white/75 text-[15px] font-medium text-center tracking-wide mt-4 px-4">
          Discover events happening near you
        </p>
      </div>

      {/* Actions */}
      <div className="relative z-10 w-full max-w-md px-6 pb-10 flex flex-col gap-3">
        <button
          data-testid="welcome-signin-btn"
          onClick={() => navigate('/login')}
          className="w-full brand-gradient text-white py-4 rounded-2xl font-extrabold text-base tracking-wide active:scale-[0.98] transition-transform"
        >
          Sign In
        </button>
        <button
          data-testid="welcome-register-btn"
          onClick={() => navigate('/register')}
          className="w-full py-4 rounded-2xl font-bold text-base text-white border-[1.5px] border-white/20 bg-white/[0.08] hover:bg-white/[0.12] active:scale-[0.98] transition-all"
        >
          Create Account
        </button>
        <button
          data-testid="welcome-guest-btn"
          onClick={() => navigate('/')}
          className="flex items-center justify-center gap-1.5 py-2.5 text-white/85 font-bold text-sm hover:text-white transition-colors"
        >
          Continue as Guest
          <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
